module.exports = __webpack_public_path__ + "img/aa1.7cbf2400.jpg";